import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { FlexCol } from '../../../Defaults/Flexbox/Flexbox';
import { FormInput } from '../../Form/FormInput';
import { prop } from '../../../../utilities';

interface Props {
  company: any;
  onChange: (e) => void;
  onBlur: (updatedData: any) => void;
  isVisible: boolean;
  problems: any;
}

function CompanyInfo({
  company,
  onChange,
  onBlur,
  isVisible,
  problems,
}: Props) {
  const { companyName, ico, dic, ic_dph } = company;

  const handleBlur = () => {
    onBlur({ ...company, name: companyName });
  };

  if (!isVisible) {
    return <EmptyWrapper />;
  }

  const { nameProblem, icoProblem, dicProblem, icDphProblem } = {
    nameProblem: prop(problems, 'name'),
    icoProblem: prop(problems, 'ico'),
    dicProblem: prop(problems, 'dic'),
    icDphProblem: prop(problems, 'ic_dph'),
  };

  return (
    <Wrapper>
      <FormInput
        name={'companyName'}
        type="text"
        label={'Firma'}
        value={companyName}
        required={true}
        onChange={onChange}
        onBlur={handleBlur}
        validMessage={nameProblem}
      />
      <FormInput
        name={'ico'}
        type="text"
        required={true}
        label={'IČO'}
        value={ico}
        onChange={onChange}
        onBlur={handleBlur}
        validMessage={icoProblem}
      />
      <FormInput
        name={'dic'}
        type="text"
        required={true}
        label={'DIČ'}
        value={dic}
        onChange={onChange}
        onBlur={handleBlur}
        validMessage={dicProblem}
      />
      <FormInput
        name={'ic_dph'}
        type="text"
        required={true}
        label={'IČ DPH'}
        value={ic_dph}
        marginBottom={0}
        onChange={onChange}
        onBlur={handleBlur}
        validMessage={icDphProblem}
      />
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  margin: ${rem(32)} 0;
`;

const EmptyWrapper = styled.div`
  margin-bottom: ${rem(24)};
`;

export { CompanyInfo };
